import update from 'immutability-helper';

import * as actions from 'constants/templateList/TemplateListActions';

export default {
  [actions.POST_DUPLICATE_TEMPLATE_SUCCESS]: (
    state,
    { listId, isCommon, data: item },
  ) =>
    isCommon
      ? state
      : update(state, {
          [listId]: {
            items: {
              $unshift: [item],
            },
          },
        }),
  [actions.DELETE_TEMPLATE_SUCCESS]: (state, { listId, itemIds }) =>
    update(state, {
      [listId]: {
        selectedItems: {
          $unset: itemIds,
        },
      },
    }),
  [actions.SORT_TEMPLATE_LIST_COLUMN]: (
    state,
    { payload: { listId, field, order } },
  ) =>
    update(state, {
      [listId]: {
        sortBy: {
          $set: field,
        },
        sortOrder: {
          $set: order,
        },
      },
    }),
};
